import { CREDIT_PACK_DEFAULT_CREDITS, type CreditPack } from '@pulsify/shared/dto'

type CreditPackRange = Pick<CreditPack, 'minCredits' | 'maxCredits' | 'stepCredits'>

/** Net price in cents of `credits` at the unit price. */
export function creditPackPrice(
  pack: Pick<CreditPack, 'unitAmount' | 'creditsPerUnit'>,
  credits: number,
): number {
  return Math.round((credits / pack.creditsPerUnit) * pack.unitAmount)
}

/**
 * Where the picker starts: the shortfall rounded up to the next step, or the default amount when
 * the shortfall is unknown; always within the range on sale.
 */
export function creditPackStartCredits(pack: CreditPackRange, shortfall?: number): number {
  const wanted =
    shortfall === undefined
      ? CREDIT_PACK_DEFAULT_CREDITS
      : Math.ceil(shortfall / pack.stepCredits) * pack.stepCredits
  return Math.min(pack.maxCredits, Math.max(pack.minCredits, wanted))
}
